export const NAVBAR_WIDTH = 240;
export const NAVBAR_COLLAPSED_WIDTH = 0;
export const NAVBAR_LOCALSTORAGE_KEY = 'workpath_navbar_collapsed';
export const NAVBAR_TRANSITION_DURATION = '0.2s';
